module.exports = __webpack_public_path__ + "img/dh.32c84c94.png";